import React from "react";
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import Scrollbars from 'react-custom-scrollbars';
import MsxIcons from "../../msx-icons";
import { PRIMARY_COLOR } from "../../../color-constants";
import I10n from "../../i10n";

const Container = styled.div`
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  max-width: 1100px;
  width: 100%;
  height: calc(100vh - 4em);
  background-color: white;
  color: #333333;
  margin: 2em;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #626469;
  margin-top: 5px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 0px 5px 5px 20px;
  background-color: #F4F4F4;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const MarkdownSpecialFormat = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  font-size: 16px !important;
  line-height: 16px !important;
  font: message-box;

  & > h4 {
    font-size: 22px !important;
    line-height: 22px !important;
    margin: 10px 0 !important;
    text-align: left !important;
  }

  & > h1 {
    font-size: 22px !important;
    line-height: 22px !important;
    margin: 10px 0 !important;
  }

  & > p {
    margin: 10px 0 !important;
  }

  & > ul {
    padding-top: 5px !important;
    padding-left: 0px !important;
    list-style: disc !important;
  }

  & > ul > li {
    margin-left: 16px !important;
    margin-bottom: 5px !important;
  }
`;

const Separator = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 2px solid #cccccc;
  margin-top: 16px;
`;

class ModalMarkdownReader extends React.PureComponent {

  handleButtonClick = () => this.props.onButtonClick();

  render = () => {
    const { markdownText } = this.props;
    return (
      <Container>
        <Header>
          <TitleWrapper>
            <Title>{this.props.title}</Title>
            <CloseIcon onClick={(e) => {
              e.preventDefault();
              this.props.closeModal();
            }}>
              <MsxIcons name="close"></MsxIcons>
            </CloseIcon>
          </TitleWrapper>
          <Subtitle>{I10n.getOrDefault(`modal.${this.props.starterType}.subtitle`, I10n.get('modal.subtitle'))}</Subtitle>
        </Header>
        <Separator></Separator>
        <Body>
          <Scrollbars>
            <div>
              <MarkdownSpecialFormat>
                <ReactMarkdown source={markdownText}></ReactMarkdown>
              </MarkdownSpecialFormat>
            </div>
          </Scrollbars>
        </Body>
      </Container>
    );
  }
}

export default ModalMarkdownReader;
